import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from './history';
// reducers
import auth, { LOGOUT, DELETE_ACCOUNT } from './reducers/auth';
import videoPlayer from './reducers/videoPlayer';
import modal from './reducers/modal';
import skills from './reducers/skills';
import journals from './reducers/journals';
import program from './reducers/program';
import module from './reducers/module';
import resources from './reducers/resources';
import completedSteps from './reducers/completedSteps';
import helps from './reducers/helps';
import recovery from './reducers/recovery';
import billing from './reducers/billing';
import staticPages from './reducers/staticPages';

const appReducer = combineReducers({
  router: connectRouter(history),
  auth,
  videoPlayer,
  modal,
  skills,
  journals,
  program,
  module,
  resources,
  completedSteps,
  helps,
  recovery,
  billing,
  staticPages
});

const rootReducer = (state, action) => {
  if ([`${LOGOUT}_SUCCESS`, `${DELETE_ACCOUNT}_SUCCESS`].includes(action.type))
    state = undefined;
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js